<template>
	<div id="service3">
		<Menu areWeinServices="true" selectedRoute="intel"/>
		<div class="colorAzul">
			<section class="secImage1" :style="{ backgroundImage: 'url(' + firstImage + ')' }">
				<div class="fondotransparenteServicio">
					<h1>{{title}}</h1>
				</div>
			</section>

			<section class="secTexto">
				<div class="textoContenidoInterno">
					<div class="html">
						<!--
						<h1 class="tituloContenidoInterno">
							<span>{{subtitle}}</span>
						</h1>
						-->
						<h2 class="subtituloContenidoInterno">We help you gather the information that you need in order to make the most informed decision in challenging situations</h2>

						<p class="parrafoContenidoInterno">
							<span>Grupo Glarus</span> can conduct background and investigations on human capital for strategic positions, potential business partners, fraud detection, to help you do your due diligence and take the best decision possible.
						</p>
						<ul class="listaContenidoInterno">
							<li>Company’s duly incorporation</li>
							<li>Fiscal situation</li>
							<li>Financial solvency</li>
							<li>Background Checks</li>
							<li>Legal and Criminal history</li>
							<li>Company’s reputation and public image</li>
							<li>Asset Searches</li>
							<li>Private Investigations</li>
						</ul>
					</div>

					<cuadro/>

				</div>
			</section>

			<section class="secImage2" :style="{ backgroundImage: 'url(' + secondImage + ')' }">
				<div class="fondoAzulServiciosGrid">
					<h1 class="headGridServices">
						<span>{{titleIcons}}</span>
					</h1>

					<div class="gridIcons" :class="{center: precautions.length <= 3}">
						<div class="precautions" v-for="item in precautions" :key="item.id">
							<span>
								<img :src="item.icon" :alt="item.altIcon">
							</span>
							<h3>{{ item.descripcion }}</h3>
						</div>
					</div>
				</div>
			</section>
		</div>

		<FooterComponent areWeinServicesFooter="true"/>
	</div>
</template>

<script>
// @ is an alias to /src

import Menu from "@/components/Menu2.vue";
import cuadro from "@/components/PopEachService.vue";
import FooterComponent from "@/components/Footer.vue";

//Imagenes del servicio
import imagen1 from "@/assets/img/servicios/3/imagen1.jpg";
import imagen2 from "@/assets/img/servicios/3/second_.jpg";
import icono01 from "@/assets/img/servicios/3/01.png";
import icono02 from "@/assets/img/servicios/3/02.png";

export default {
	name: "servicio03",
	components: {
		Menu,
		cuadro,
		FooterComponent
	},
	mounted: function() {
		this.$nextTick(function() {
			document.title = "Glarus Group - Private Investigations, Background Checks, and Intelligence in Mexico";

			this.numberPrecautions = this.precautions.lenght;
			this.cuentaPrecautions();
		});
	},
	data: function() {
		return {
			title: "INVESTIGATIONS AND INTELLIGENCE IN MEXICO",
			// subtitle: "Research and intelligence",
			// thirdTitle: "Certainty when choosing new associates.",
			firstImage: imagen1,
			secondImage: imagen2,
			titleIcons: "We Provide:",
			numberPrecautions: null,
			iconsPos: "",

			precautions: [
				{
					id: "2",
					icon: icono02,
					altIcon: "glarus service 3",
					descripcion: "Background Checks"
				},
				{
					id: "1",
					icon: icono01,
					altIcon: "glarus service 3",
					descripcion: "Due Diligence Investigations"
				},
				{
					id: "3",
					icon: icono02,
					altIcon: "glarus service 3",
					descripcion: "Asset Searches"
				}
			]
		};
	},
	methods: {
		cuentaPrecautions() {
			//	 if(this.numberPrecautions < 3 ){
			//	 } else {
			//	 }
			//console.log("la longitud de precautions es " + this.numberPrecautions)
		}
	}
};
</script>




<style lang="less">
@import url("../../assets/less/soloVariables.less");
@import url("../../assets/less/cssServiciosComponent.less");
</style>
